export const richTextToText = (richText: any[]): string => {
  let text = ''

  for (const node of richText) {
    if (node.text) {
      text += node.text
    }

    if (node.text === '') {
      text += ' '
    }

    if (node.children) {
      text += richTextToText(node.children)
    }
  }

  return text
}
